import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';
import appLayoutStyles from '../AppLayout/index.module.scss';
import BrandingHeader from '@/components/BrandingHeader';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import { getBrandingLogoUrl } from '@/utils/logo';
import { useContext } from 'react';
import { Footer } from '@/components/Footer/Footer';

const BasicLayout = () => {
  const { isMobile } = usePlatform();
  const { experienceSettings, theme } = useContext(PageContext);

  const isDarkModeEnabled = experienceSettings?.color.isDarkModeEnabled ?? false;
  const branding = experienceSettings?.branding;
  const logo = branding ? getBrandingLogoUrl({ theme, branding, isDarkModeEnabled }) : null;

  return (
    <>
      {experienceSettings && (
        <BrandingHeader
          className={classNames(styles.header, layoutClassNames.brandingHeader)}
          logo={logo}
        />
      )}
      <div className={styles.viewBox}>
        <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
          </main>
          {isMobile && <Footer className="outer-footer basic-layout" />}
        </div>
        <div className={appLayoutStyles.decorationContainer}>
          <div className={appLayoutStyles.gradientBlob1} />
          <div className={appLayoutStyles.gradientBlob2} />
          <div className={appLayoutStyles.gradientBlob3} />
        </div>
      </div>
      {!isMobile && <Footer className="outer-footer basic-layout" />}
    </>
  );
};

export default BasicLayout;
